const aufenthaltfreieCountries = [
  'BE',
  'BG',
  'DK',
  'DE',
  'EE',
  'FI',
  'FR',
  'GR',
  'NL',
  'IT',
  'IE',
  'HR',
  'EE',
  'LT',
  'LU',
  'MT',
  'AT',
  'PL',
  'PT',
  'RO',
  'SE',
  'SK',
  'SI',
  'ES',
  'CZ',
  'HU',
  'CY',
  'CH',
  'NO',
  'LI',
  'IS',
];

export default aufenthaltfreieCountries;
